<template>
    <div>
        <Breadcrumbs main="Couriers" title="Courier List"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.patient >
                                
                                <i class="icon-shopping-car"> </i> New Courier</a
                              >
                              <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <!-- <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                            </div>

                            <!-- patient form -->
                            <b-modal id="patient" ref="vendorModal" :title="`${( editCourier ? 'Edit Courier : '+editCourier : 'Create New Courier ')} `" ok-title="Done" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ editCourier ? 'Edit Courier : '+editCourier : 'Create New Courier ' }} <b-button pill size="xs" type="reset" @click="resetCourier()" variant="outline-danger">Reset</b-button></h5>
                                
                              </template>
                              <!-- {{ patient }} -->
                              <p class="px-3">Kindly fill form to add a <b>Courier</b>
                               </p>
                              <!-- <p><b>#NB:</b> A 4-Digit <b>OTP verify Code</b> will be sent to <b>Patient's Tel.</b> </p> -->


                                <form id="vendorForm" @submit.stop.prevent="submitCourier" class="p-2 px-3">
                                    
                                    
                                    <figure v-if="dropFile || editCourier" class="b-image-wrapper image is-16by9 m-1">
                                        <b-img
                                            rounded
                                            :src="img"
                                            style="width:100%"
                                            ratio="16by9"
                                        >
                                        </b-img>
                                    </figure>

                                    <div class="row form-group mt-2">
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Fullname: <span class="txt-primary">( Name )</span></label>
                                                <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                required 
                                                v-model="courier.name"
                                                placeholder="Name">
                                            </b-form-input>
                                            
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Profile image: <span @click="switchImage" class="badge badge-primary"> Switch </span></label>
                                            <b-form-file 
                                                v-if="isImageUpload"
                                                accept="image/jpeg, image/png" 
                                                v-model="dropFile" 
                                            ></b-form-file>

                                            <b-form-input 
                                              v-else
                                            autocomplete="off"
                                            v-model="courier.image" 
                                            type="tel" 
                                            placeholder="Image url ">
                                            </b-form-input>
                                        </div>
                                    </div>

                                    
                                    <div class="row form-group mt-2">
                                        <div class="col-sm-3 col-4">
                                            <label class="col-form-label" type="text" for="recipient-name">CountryCode<span class="txt-primary"></span></label><br>
                                            <vue-country-code
                                                class=" p-1"
                                                
                                                @onSelect="onSelect"
                                                :enabledCountryCode="true"
                                                :preferredCountries="[ 'us', 'gb', 'gh','ng','ke']"
                                                >
                                            </vue-country-code>
                                        </div>
                                        <div class="col-sm-4 col-3">
                                            <label class="col-form-label" type="text" for="recipient-name">Country</label>
                                            <b-form-input 
                                                autocomplete="0"
                                                required 
                                                v-model="courier.country.name"
                                                placeholder="Name">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-5 col-5">
                                            <label class="col-form-label" for="recipient-name">Contact: </label>
                                          <b-form-input 
                                            required 
                                            autocomplete="off"
                                            v-model="courier.phone.tel" 
                                            type="tel" 
                                            placeholder="Contact ">
                                            </b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="row form-group mt-2">
                                      <div class="col-sm-9 col-9">
                                    
                                        <label class="col-form-label" for="recipient-name">Select Couriers: </label>
                                        <multiselect v-model="vendorSelect" tag-placeholder="Add a vendor" placeholder="Search or add a vendor" label="name" track-by="code" :options="vendorOptions" :multiple="true" :taggable="true" @tag="addCourier"></multiselect>
                                      </div>
                                      <div class="col-sm-3 col-3">
                                          <label class="col-form-label" for="recipient-name">Type: 
                                            <!-- <span class="badge badge-primary" @click="switchType"> swap </span> -->
                                          </label>
                                            <b-form-select required v-model="courier.type" :options="typeOptions"></b-form-select>
                                            <!-- <b-form-input 
                                            v-else
                                            v-model="product.type" 
                                            placeholder="Type ">
                                            </b-form-input> -->
                                      </div>
                                    </div>

                                    <div class="row form-group mt-2">
                                        <!-- <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input required v-model="patient.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div> -->
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">ID Type: </label>
                                          <!-- <b-form-input 
                                            required 
                                            autocomplete="off"
                                            v-model="courier.phone.tel" 
                                            type="tel" 
                                            placeholder="Business Contact ">
                                            </b-form-input> -->
                                            <b-form-select v-model="courier.ID.type" :options="IDType"></b-form-select>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">ID Number: </label>
                                          <b-form-input required v-model="courier.ID.number" placeholder="ID Number "></b-form-input>
                                        </div>
                                    </div>

                                    <div class="row form-group mt-2">
                                        <!-- <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input required v-model="patient.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div> -->
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Delivery Method: </label>
                                          
                                          <b-form-select v-model="courier.deliveryMethod" :options="deliveryMethod"></b-form-select>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Device ID: </label>
                                            <b-form-input 
                                                required 
                                                v-model="courier.deviceId"
                                                placeholder="Device">
                                            </b-form-input>
                                        </div>
                                    </div>

                                    <!-- <b-form-group style="border:0" label="Individual radios" v-slot="{ ariaDescribedby }"> -->
                                      
                                    <!-- </b-form-group> -->

                                    <div class="row ">
                                      <div class="col-sm-4 col-4">
                                            <label class="col-form-label" type="text" for="recipient-name">Vehicle Brand: </label>
                                            <b-form-input 
                                                required 
                                                v-model="courier.vehicle.brand"
                                                placeholder="Brand">
                                            </b-form-input>
                                        </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Vehicle Model: <span class="txt-primary">  </span></label>
                                        <b-form-input 
                                          required
                                          v-model="courier.vehicle.model"
                                          placeholder="Model">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Registration:</label>
                                        <b-form-input :required="editCourier ? false : true" v-model="courier.vehicle.registration" type="text" text-field="item" placeholder="Registration">
                                        </b-form-input>
                                      </div>
                                    </div>
                                    
                                    
                                    <div class="row form-group mt-2">
                                      
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Active:</label>
                                        <!-- <b-form-select required v-model="courier.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="courier.active" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label p-2 " for="recipient-name">Verified:</label>
                                        <b-form-radio-group required :options="verifiedOptions" v-model="courier.verified" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label p-2 " for="recipient-name">Online:</label>
                                        <b-form-radio-group required :options="onlineDeliveryOptions" v-model="courier.online" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                    </div>

                                    <div class="row form-group mt-2">
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" type="text" for="recipient-name">Location:  <a target="_blank" class="badge badge-primary" href="https://www.google.com/maps"> Google maps </a> </label>
                                        <b-form-input 
                                        autocomplete="0"
                                        required 
                                        v-model="courier.locationName"
                                        placeholder="Business Location">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Location: <span class="txt-primary"> ( Lat, Lng ) </span></label>
                                        <b-form-input required v-model="courier.loc" text-field="item" placeholder="Longitude">
                                        </b-form-input>
                                      </div>
                                      
                                    </div>

                                    <!-- <label class="col-form-label" for="message-text">Address: <span class="txt-primary">( Location / GPS Address )</span></label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                      placeholder="Enter Address"
                                      v-model="patient.address"
                                    ></b-form-textarea> -->
                                    <b-button block  type="submit" :disabled="submitting" variant="primary">Submit</b-button>

                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <b-modal id="request" ref="requestModal" ok-title="Done" class="theme-modal">
                              <template #modal-header>
                                <h5>Patient Request Form </h5>
                              </template>
                              <div class="px-3">
                                <p>Kindly fill input below to request access to <b>patient's Data</b>, <br><b>#NB:</b> alert patient to accept / give you code.</p>
                                <h5>Criteria </h5>
                                <ol>
                                  <li>Patient No. or Contact</li>
                                  <li>Fullname and Date of Birth</li>
                                </ol>
                                <!-- <p><b>1. </b><br><b>2. </b></p> -->
                                <p>Request modes: <b>InApp:</b><i class="text-muted">via app</i> and <b>OTP:</b><i class="text-muted">one-time access code</i></p>
                              </div>

                              <form id="requestForm" @submit.stop.prevent="requestPatient" class="p-2 px-3">
                                    
                                    <div class="row form-group pb-2">
                                        
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input autofocus autocomplete="off" v-model="access.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Contact: </label>
                                          <b-form-input autocomplete="off" v-model="access.tel" type="tel" placeholder="Contact "></b-form-input>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row form-group pb-1">
                                        
                                        <div class="col-sm-7 col-6">
                                          <label class="col-form-label" type="text" for="recipient-name">Fullname:</label>
                                          <b-form-input autocomplete="off" v-model="access.fullname" placeholder="Fullname"></b-form-input>
                                          
                                        </div>
                                        <div class="col-sm-5 col-6">
                                          <label class="col-form-label" for="recipient-name">Date of Birth:</label>
                                          <b-form-input v-model="access.dob" type="date" placeholder="Patient No"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="row ">
                                      <div class="col-sm-5 col-6">
                                        <label class="col-form-label" for="recipient-name">Request Mode:</label>
                                        <b-form-radio-group :options="requestOptions" v-model="access.request" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-7 col-6">
                                        <label class="col-form-label" for="recipient-name">Note:</label>
                                        <b-form-input v-model="access.note" type="tel" placeholder="Add note (Optional) "></b-form-input>
                                      </div>
                                    </div>

                                    <br>
                                    <br>
                                    <b-button v-if="requestLoading" block type="submit" variant="primary" disabled>
                                      <div class="loader-box" style="height:30px">
                                        <div class="loader-2"></div>
                                      </div>
                                    </b-button> 
                                    <b-button block v-else type="submit" variant="primary"> Request Access</b-button>
                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <!-- import patient -->
                            <b-modal id="importPatient" size="lg" title="Import Patients" ok-title="Ok" class="theme-modal">
                              <h5>Choose an Excel file</h5>
                              <p>Choose a <b> .csv, .xls, .xlsx </b> format. File should not exceed <b>0.7MB</b>  must contain not more than <b>3000 records</b></p>
                              <br>
                              <h5>Data presentation below</h5>

                              <table class="table ">
                                <thead>
                                  <th>Patient No</th>
                                  <th>Name</th>
                                  <th>Dob</th>
                                  <th>Gender</th>
                                  <th>Contact</th>
                                  <th>Email</th>
                                  <th>Status</th>
                                  <th></th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class=""> <i>PT0001</i></td>
                                    <td> <i>John Doe</i></td>
                                    <td> <i>1990-01-01</i></td>
                                    <td> <i>Male</i></td>
                                    <td> <i>0200000001</i></td>
                                    <td> <i>john.doe@email.com</i></td>
                                    <td> <i>Inactive</i></td>
                                    <td> <i></i></td>
                                  </tr>
                                  <tr>
                                    <td class=""> <i>PT0002</i></td>
                                    <td> <i>John Public</i></td>
                                    <td> <i>1990-01-01</i></td>
                                    <td> <i>Male</i></td>
                                    <td> <i>0200000001</i></td>
                                    <td> <i></i></td>
                                    <td> <i>Active</i></td>
                                    <td> <i></i></td>
                                  </tr>
                                </tbody>
                              </table>
                              <br>
                              <div class="form-group">
                                <h5>Upload Excel file</h5>
                                <vue-dropzone id="singledropzone" :options="singledropzoneOptions" class="dropzone digits" v-on:vdropzone-sending="sendingEvent">                                
                                </vue-dropzone>
                              </div>
                            </b-modal>

                            <!-- view vendor -->
                            <b-modal id="viewCourier" ref="viewvendorModal" :title="'View Courier : '+viewCourier.name" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="viewCourierfields" :items="[viewCourier]">

                                <template #cell(image)="row">
                                    <figure v-if="row.item.image" class="b-image-wrapper image is-16by9 m-1">
                                        <a :href="row.item.image" target="_blank">
                                            <b-img
                                                rounded
                                                :src="row.item.image"
                                                style="width:40%;"
                                            >
                                            </b-img>
                                        </a>
                                    </figure>
                                </template>

                                <template #cell(name)="row">
                                <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                    
                                  {{ row.item.status }}  </a @click="status(row.item.access[0])"
                                  > -->
                                  <div @click="view(row.item)" style="font-weight:500;" class="txt-primary pb-2"
                                  v-b-tooltip.hover="{ html:true }"  :title="'<b>ID Type:</b> '+row.item.ID.type +'<br>'+ '<b>ID Num:</b> '+row.item.ID.number">
                                    {{ row.item.name }} 
                                  </div>
                                  <a class="txt-dark" target="_blank" :href="`https://www.google.com/maps/search/${row.item.locationName}/${row.item.location[0]},${row.item.location[1]}?entry=tts`" v-b-tooltip.hover title="View location" style="font-size:0.8rem;"> {{ row.item.locationName }} </a>
                              </template>

                              <template #cell(active)="row">
                                <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                    
                                  {{ row.item.status }}  </a @click="status(row.item.access[0])"
                                  > -->
                                  <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                    {{ (row.item.active ? 'Active' : 'Inactive') }}
                                  </div>
                              </template>

                              <template #cell(available)="row">
                                <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                    
                                  {{ row.item.status }}  </a @click="status(row.item.access[0])"
                                  > -->
                                  <div v-b-tooltip.hover @click="available(row.item)" title="Available status" :class="`btn ${ (row.item.available ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                    {{ (row.item.available ? 'Yes' : 'No') }}
                                  </div>
                              </template>

                              <template #cell(deliveryMethod)="row">
                                
                                  <div style="font-weight:400;" v-b-tooltip.hover="{ html:true }"  :title="'<b>Brand:</b> '+row.item.vehicle.brand +'<br>'+ '<b>Model:</b> '+row.item.vehicle.model +'<br> '+ '<b>Reg:</b> '+row.item.vehicle.registration" >
                                    {{ row.item.deliveryMethod }}

                                    <div :class="`btn ${ (row.item.type == 'standard' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ row.item.type }}
                                    </div>
                                  </div>
                              </template>

                              <template #cell(ID)="row">
                                
                                <div>
                                  <b>ID Type:</b> {{ row.item.ID.type }} <br> <b>ID Number:</b> {{ row.item.ID.number }}
                                </div>
                            </template>

                              <template #cell(vehicle)="row">
                                
                                <div>
                                  <b>Brand:</b> {{ row.item.vehicle.brand }} <br> <b>Model:</b> {{ row.item.vehicle.model }} <br> <b>Reg:</b> {{ row.item.vehicle.registration }}
                                </div>
                            </template>


                              <template #cell(online)="row">
                                <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                    
                                  {{ row.item.status }}  </a @click="status(row.item.access[0])"
                                  > -->
                                  <div v-b-tooltip.hover @click="online(row.item)" title="Online status" :class="`btn ${ (row.item.online ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                    {{ (row.item.online ? 'Online' : 'Offline') }}
                                  </div>
                              </template>

                              <template #cell(verified)="row">
                                  <a v-b-tooltip.hover @click="verify(row.item)" :title="!row.item.verified ? 'Click to verify' : ''" :class="`btn ${ (row.item.verified ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                          {{ (row.item.verified ? 'Verified' : 'not verified') }}
                                        </a>
                              </template>
                        

                              <template #cell(shops)="row">
                                <!-- <span v-if="row.item.dob" v-b-tooltip.hover class="txt-primary" :title="new Date(row.item.dob).toDateString().substr(4)"> {{ calculateAge(row.item.dob) }} years </span> -->

                                <span v-for="shop in row.item.shops" :key="shop" v-b-tooltip.hover :class="`btn btn-primary btn-xs btn-pill mr-2 mb-2`">
                                          {{ shop }}
                                        </span>
                              </template>

                              <template #cell(phone)="row">

                                <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                    {{ row.item.phone.countryCode+row.item.phone.tel }}
                                  </a>
                              </template>

                              <template #cell(createdAt)="row">
                                    {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                              </template>

                              </b-table>
                            </b-modal>
                            

                          </b-col>
                      </b-row>
                      <b-modal id="orderModal" size="lg" ref="orderModal" :title="'View Orders : '+orderTitle" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="orderTable"
                                :items="allOrders"
                                :fields="orderfields"
                                :per-page="perOrderPage"
                              >
                                <template #cell(body)="row">
                                    <u class="txt-primary"> {{ row.item.title }} </u>
                                    <p> {{ row.item.body }} </p>
                                </template>
                                

                                <template #cell(date)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="editcomment(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                  <b-button variant="danger" @click="delcomment(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                </template>
                              </b-table>
                            </b-modal>
                    <!-- {{ selected }} -->
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="orders(row.item)">Orders</b-dropdown-item>
                              <b-dropdown-item @click="pickups(row.item)">Pickup request</b-dropdown-item>
                              <b-dropdown-item @click="edit(row.item)">Edit</b-dropdown-item>
                              <b-dropdown-item @click="view(row.item)">View </b-dropdown-item>
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <b-dropdown-divider></b-dropdown-divider>
                              <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item>
                          </b-dropdown>
                          </template>

                          <template #cell(name)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div @click="view(row.item)" style="font-weight:500;" class="txt-primary pb-2"
                              v-b-tooltip.hover="{ html:true }"  :title="'<b>ID Type:</b> '+row.item.ID.type +'<br>'+ '<b>ID Num:</b> '+row.item.ID.number">
                                {{ row.item.name }} 
                              </div>
                              <a class="txt-dark" target="_blank" :href="`https://www.google.com/maps/search/${row.item.locationName}/${row.item.location[0]},${row.item.location[1]}?entry=tts`" v-b-tooltip.hover title="View location" style="font-size:0.8rem;"> {{ row.item.locationName }} </a>
                          </template>

                          <template #cell(active)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.active ? 'Active' : 'Inactive') }}
                              </div>
                          </template>

                          <template #cell(available)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="available(row.item)" title="Available status" :class="`btn ${ (row.item.available ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.available ? 'Yes' : 'No') }}
                              </div>
                          </template>

                          <template #cell(deliveryMethod)="row">
                            
                              <div style="font-weight:400;" v-b-tooltip.hover="{ html:true }"  :title="'<b>Brand:</b> '+row.item.vehicle.brand +'<br>'+ '<b>Model:</b> '+row.item.vehicle.model +'<br> '+ '<b>Reg:</b> '+row.item.vehicle.registration" >
                                {{ row.item.deliveryMethod }}
                                <div :class="`btn ${ (row.item.type == 'standard' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ row.item.type }}
                                    </div> 
                              </div>
                          </template>


                          <template #cell(online)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover title="Online status" @click="online(row.item)" :class="`btn ${ (row.item.online ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.online ? 'Online' : 'Offline') }}
                              </div>
                          </template>

                          <template #cell(verified)="row">
                              <a v-b-tooltip.hover @click="verify(row.item)" :title="!row.item.verified ? 'Click to verify' : ''" :class="`btn ${ (row.item.verified ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.verified ? 'Verified' : 'not verified') }}
                                    </a>
                          </template>
                    

                          <template #cell(shops)="row">
                            <!-- <span v-if="row.item.dob" v-b-tooltip.hover class="txt-primary" :title="new Date(row.item.dob).toDateString().substr(4)"> {{ calculateAge(row.item.dob) }} years </span> -->

                            <span v-for="shop in row.item.shops" :key="shop" v-b-tooltip.hover :class="`btn btn-primary btn-xs btn-pill mr-2 mb-2`">
                                      {{ shop }}
                                    </span>
                          </template>

                          <template #cell(phone)="row">

                            <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                {{ row.item.phone.countryCode+row.item.phone.tel }}
                              </a>
                          </template>

                          <template #cell(createdAt)="row">
                                {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ items.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      isImageUpload: true,
      img: '',
      pro: '',
      dropFile: null,
      productFile: null,
      editCourier: false,
      access: {
        no: '',
        tel: '',
        fullname: '',
        dob: '',
        note: '',
        request: 'OTP'
      },
      requestLoading: false,
      patient: {
        fullname: '',
        dob: '',
        gender: '',
        tel: '',
        email: '',
        address: ''
      },
      product: {
        product: '',
        category: null,
        tags: '',
        image: '',
        price: 0,
        discount: 0,
        type: null,
        details: '',
      },
      vendorSelect: [],
      viewProduct: null,
      editProduct: null,
      allProducts: [],
      submitting: false,
      orderTitle: '',
      allOrders: [],
      courier: {
        image: '',
        name: '',
        type: 'standard',
        ID: {
            type: null,
            number: ''
        },
        phone: {
            countryCode: '',
            tel: ''
        },
        country: {
            name: '',
            currency: '',
            code: ''
        },
        deviceId: '',
        vehicle: {
          type: this.deliveryMethod,
          brand: '',
          model: '',
          registration: '',
        },
        online: '',
        locationName: '',
        loc: '',
        deliveryMethod: null,
        verified: '',
        active: null,
        vendors: []
      },
      viewCourier: {},
      comment: {
        editComment: false,
        title: '',
        body: '',
        name:'',
        tel: '',
        patientno: '',
        id: ''
      },
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      IDType: [
        { value: null, text: 'Select ' },
        { value: 'Ghana Card', text: 'Ghana Card' },
        { value: 'Driver\'s License', text: 'Driver\'s License' },
        { value: 'Voter\'s ID', text: 'Voter\'s ID' }
      ],
      deliveryMethod: [
        { value: null, text: 'Select ' },
        { value: 'Car', text: 'Car' },
        { value: 'Motorbike', text: 'Motorbike' },
        { value: 'Bicycle', text: 'Bicycle' }
      ],
      typeOptions: ['standard', 'reserved'],
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      verifiedOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],  
      onlineDeliveryOptions:[
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      pickupOptions:[
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      requestOptions:[
        { value:'InApp', item: 'InApp' },
        { value:'OTP', item: 'OTP' }
      ],
      vendorOptions: [],
      tablefields: [
        { key: 'name', label: 'Name', sortable: true, },
        { key: 'deliveryMethod', label: 'Vehicle', sortable: true },
        { key: 'shops', label: 'Shop List', sortable: true, },
        { key: 'phone', label: 'Contact' },
        { key: 'active', label: 'Status', sortable: true, },
        { key: 'online', label: 'Online', sortable: true, },
        { key: 'available', label: 'Available', sortable: true, },
        { key: 'locationName', label: 'Last Location', sortable: true, },
        // { key: 'ratings', label: 'Rated', sortable: true, },
        { key: 'verified', label: 'Profile', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      viewCourierfields: [
        { key: 'image', label: 'Profile', sortable: true, },
        { key: 'name', label: 'Name', sortable: true, },
        { key: 'deliveryMethod', label: 'Vehicle', sortable: true, },
        { key: 'shops', label: 'Shop List', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: false, },
        { key: 'ID', label: 'ID', sortable: false, },
        { key: 'vehicle', label: 'Vehicle', sortable: false, },
        { key: 'active', label: 'Status', sortable: true, },
        { key: 'online', label: 'Online', sortable: true, },
        { key: 'available', label: 'Available', sortable: true, },
        { key: 'locationName', label: 'Last Location', sortable: true, },
        { key: 'verified', label: 'Profile', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
      ],
      items: [],
      commentfields: [
        { key: 'body', label: 'Title & Comment', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      productfields: [
        { key: 'product', label: 'Product', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'price', label: 'Price', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      orderfields: [
        { key: 'orderNo', label: 'Order No', sortable: false, },
        { key: 'shop', label: 'shop', sortable: true, },
        { key: 'userName', label: 'Username', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'totalPrice', label: 'Total Price', sortable: true, },
        { key: 'deliveryFee', label: 'Delivery', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      comments: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'shop',
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      sortProductBy: 'product',
      currentProductPage: 1,
      totalProductRows: 1,
      perProductPage: 5,
      totalOrderRows: 1,
      perOrderPage: 5,
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    Multiselect
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    },
    vendorSelect() {
      if (this.vendorSelect.length > 0) {
        //
        this.courier.vendors = this.vendorSelect.map(courier => courier.code)
        
      }
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {
      axios.get('/courier/')
        .then(response=>{
          //
          this.items = response.data
          this.totalRows = this.items.length
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

        axios.get('/shop')
        .then(response=>{
          //
          //   this.items = response.data
          const vendors = response.data.map(courier => courier.name)
          this.vendorOptions = []
          //   this.vendorOptions  = [...new Set(vendors)]
        //   const vendorList = []
          
          for (let index = 0; index < vendors.length; index++) {
            const value = { code: vendors[index], name: vendors[index] };
            this.vendorOptions.push(value)
          }
          console.log(this.vendorOptions)
          
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })
    },
    resetProduct() {
        this.allProducts = []
    },
    resetCourier() {
      this.editCourier = false
      this.vendorSelect = []
      this.dropFile = null
      this.img = null
      this.courier.image = ''
      this.courier.name = ''
      this.courier.deliveryMethod = null
      this.courier.ID.type = null
      this.courier.ID.number = ''
      this.courier.vehicle.brand = ''
      this.courier.vehicle.model = ''
      this.courier.vehicle.registration = ''
      this.courier.locationName = ''
      this.courier.deviceId = ''
      this.courier.loc = ''
      this.courier.verified = ''
      this.courier.active = ''
      this.courier.online = ''
      this.courier.phone = {
            countryCode: '',
            tel: ''
      }
      this.courier.country = {
            name: '',
            currency: '',
            code: ''
      }
    },
    resetComment() {
      this.comment.editComment = false
      this.comment.patientno = ''
      this.comment.tel = ''
      this.comment.name = ''
      this.comment.title = ''
      this.comment.body = ''
    },
    addCourier(shop) {
      this.vendorOptions.push(shop)
      this.value.push(shop)
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    sendingEvent (file, xhr, formData) {
        formData.append('paramName', 'some value or other');

        console.log(file)
    },
    successUpload(file, response){
        console.log(file, response)
    },
    failedUpload(file, message, xhr) {
        console.log(file, message, xhr)
    },
    requestPatient(){
      let url = '/patient/request'
      let method = axios.post
      // make uppercase
      this.access.no = this.access.no.toUpperCase()

      // validate
      if ((this.access.no == "" && this.access.tel == "") && (this.access.fullname == "" || this.access.dob == "")){

        this.$swal({
          title:"Warning!",
          text: "Kindly follow Critera for data input!",
          type:'warning'
        });

        return
      }

      this.requestLoading = true

      method(url, this.access)
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          timer: 2000,
          type:'success'
        });

        //
        this.requestLoading = false
        
        //
        this.$refs.requestModal.hide()

        if (this.access.request == "OTP"){
          //
          this.code(this.access)
        }
        
        //
        this.fetchData()

      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });

         //
        this.requestLoading = false

      })

    },
    submitCourier(){

      this.submitting = true

      let url
      let method

      if (this.editCourier) {
        url = '/courier/'+this.editCourier
        method = axios.patch;

        //
        const loc = this.courier.loc.split(',')
        this.courier.location = [ parseFloat(loc[0]), parseFloat(loc[1]) ]
        // this.courier.categories = this.courier.cat.split(',')

      } else {
        url = '/courier'
        method = axios.post;
        //
        const loc = this.courier.loc.split(',')
        this.courier.location = [ parseFloat(loc[0]), parseFloat(loc[1]) ]
        // this.courier.categories = this.courier.cat.split(',')

        // if (this.allProducts.length > 0) {
        //     this.courier.products = this.allProducts
        // }
      }

      const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
      // upload to cloudinary first
      if (this.dropFile || this.courier.image){
          //
          const formData = new FormData()
          formData.append('upload_preset', 'qwwhqvhe')
          formData.append('folder', 'couriers/')
          // formData.append('public_id', this.dropFile.name)
          formData.append('file', this.dropFile)

          // 
          if (this.courier.image && !this.dropFile) {
            //
            method(url, this.courier)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.vendorModal.hide()
                    //
                    this.fetchData()
                    
                    this.submitting = false

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

            return
          }

          fetch(cloudURL, {
              method: 'POST',
              body: formData
          }).then(async response=> {
                
                const data = await response.json()

                if (!response.ok) {
                    const error = (data && data.message) || response.status
                    return Promise.reject(error)
                }

                //
                this.courier.image = data.secure_url

                method(url, this.vendor)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.vendorModal.hide()
                    //
                    this.submitting = false
                    //
                    this.fetchData()
                    

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

          })

      }

      
    },
    orders(data) {
        // modal
        this.$refs.orderModal.show()
        //
        this.orderTitle = data.name

        //
        axios.get('/orders/courier/'+data.name).then( response=>{

            //
            this.allOrders = response.data
            this.totalOrderRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    pickups(data) {
        // modal
        this.$refs.orderModal.show()
        //
        this.orderTitle = data.name

        //
        axios.get('/orders/courier/pickup?courier='+data.name).then( response=>{

            //
            this.allOrders = response.data
            this.totalOrderRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    edit(data) {
      // modal
      this.$refs.vendorModal.show()
      this.editCourier = data.name
      // form
      const courier = {}
      courier.name = data.name
      this.vendorSelect = data.shops.map( vend => ({ code: vend, name: vend }) )
      courier.phone = data.phone
      courier.ID = data.ID
      courier.vehicle = data.vehicle
      courier.type = data.type
      courier.active = data.active
      courier.status = data.status
      courier.verified = data.verified
      courier.online = data.online
      courier.deviceId = data.deviceId
      courier.deliveryMethod = data.deliveryMethod
      courier.location = data.location
      courier.locationName = data.locationName
      courier.image = data.image
      
      
      this.img = data.image
      this.courier.image = courier.image
      this.courier.name = courier.name
      this.courier.phone = courier.phone
      this.courier.ID = courier.ID
      this.courier.vehicle = courier.vehicle
      this.courier.type = courier.type
      this.courier.active = courier.active
      this.courier.status = courier.status
      this.courier.verified = courier.verified
      this.courier.online = courier.online
      this.courier.deviceId = courier.deviceId
      this.courier.deliveryMethod = courier.deliveryMethod
      this.courier.location = courier.location
      this.courier.locationName = courier.locationName
      this.courier.image = courier.image
      // this.courier.loc = courier.loc
      
      this.isImageUpload = courier.image ? false : true

      this.courier.loc = courier.location.join(",")

    },
    code(data){
      // modal
      this.$refs.enterCodeModal.show()

      this.codeData.fullname = data.fullname
      this.codeData.tel = data.tel
      this.codeData.dob = data.dob
      this.codeData.patientno = data.patientno
      this.codeData.no = data.no
      //
    },
    view(data){
      // modal
      this.$refs.viewvendorModal.show()

      this.viewCourier = data
      //
    },
    switchImage() {
        this.isImageUpload = this.isImageUpload ? false : true
    },
    submitCode(){

      let url = '/patient/request/code'
      let method =  axios.post

      if (!this.codeData.code ) {
        return this.$swal({
          title:"Oops!",
          text: "Kindly enter access code!",
          type:'warning'
        });
      }

      method(url, this.codeData )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        //
        this.$refs.enterCodeModal.hide()
        //
        this.fetchData()
        //
        this.codeData = {}
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    addcomment(data){
      // modal
      this.resetComment()
      this.$refs.addCommentModal.show()
      this.comment.name = data.fullname
      this.comment.tel = data.tel
      this.comment.patientno = data.patientno
      this.comment.title = ''
      this.comment.body = ''
      
    },
    editcomment(data){
      // modal
      this.$refs.addCommentModal.show()
      this.comment.editComment = this.comment.name
      this.comment.id = data._id
      this.comment.title = data.title
      this.comment.body = data.body
      
    },
    viewcomment(fullname, tel){
      // modal
      this.$refs.viewCommentModal.show()
      this.comment.tel = tel
      this.comment.name = fullname

      axios.get('/patient/comment/'+tel)
      .then(response=>{
        //
        this.comments = response.data
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    delcomment(data) {

      this.$swal({
				text:`Are you sure you want to delete '${data.title}'?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/patient/comment/'+this.comment.tel+'/'+data._id)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: `'${data.title}' `+response.data,
                type:'success'
              });
              //
              this.viewcomment(this.comment.name, this.comment.tel)
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    submitComment(){

      let url
      let method

      if (this.comment.editComment) {
        url = '/patient/comment/'+this.comment.editComment
        method = axios.patch;
      } else {
        url = '/patient/comment'
        method = axios.post;
      }

      method(url, { patient: { fullname: this.comment.name, tel: this.comment.tel }, title: this.comment.title, body: this.comment.body, id: this.comment.id} )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        //
        this.$refs.addCommentModal.hide()
        
        this.viewcomment(this.comment.name, this.comment.tel)
        //
        
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    status(data) {
      //
      axios.post('/courier/status', { name: data.name, phone: data.phone, status: data.active })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    verify(data) {
        // if (data.verified) {
        //     return
        // }
      //
      axios.post('/courier/verified', { name: data.name, phone: data.phone, status: data.verified  })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    online(data) {
        // if (data.verified) {
        //     return
        // }
      //
      axios.post('/courier/online', { name: data.name, phone: data.phone, status: data.online  })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    available(data) {
        // if (data.verified) {
        //     return
        // }
      //
      axios.post('/courier/available', { name: data.name, phone: data.phone, status: data.available  })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    del(data) {

      this.$swal({
				text:`Are you sure you want to delete Courier ${data.nam}?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/courier/'+data.name)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.fetchData()
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    formatPrice(price) {
        return price.toFixed(2)
    },
    getDiscount(price, disc) {
            return ((100 - disc)/100) * price;
    },
    onSelect({name, iso2, dialCode}) {
        // this.form.code = "+"+dialCode
        this.courier.country.name = name.split("(")[0].trim()
        this.courier.country.currency = dialCode == "233" ? iso2+"₵" : iso2
        this.courier.country.code = "+"+dialCode
        this.courier.phone.countryCode = "+"+dialCode
        console.log(name, iso2, dialCode);
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>